

import React, { useCallback, useContext, useEffect, useState } from 'react';
import { LayoutContext } from './context/LayoutContext';

const AppFooter = () => {
    const { layoutConfig } = useContext(LayoutContext);
    const INITIAL_TIMEOUT = 1800; // Set timeout duration in seconds (e.g., 300 seconds = 5 minutes).
    const [timeLeft, setTimeLeft] = useState<number>(INITIAL_TIMEOUT);

    const resetTimeout = useCallback(() => {
        setTimeLeft(INITIAL_TIMEOUT); // Reset timer back to original.
    }, [INITIAL_TIMEOUT]);

    const formatTime = (seconds: number): string => {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
    };

    useEffect(() => {
        // Update timer countdown
        if (timeLeft <= 0) return;

        const timer = setInterval(() => {
            setTimeLeft((prevTime) => prevTime - 1);
        }, 1000);

        return () => clearInterval(timer); // Cleanup on component unmount or timeout reset.
    }, [timeLeft]);

    useEffect(() => {
        // Reset timeout on user activity
        const handleUserActivity = () => resetTimeout();

        // Add event listeners
        window.addEventListener('mousemove', handleUserActivity);
        window.addEventListener('scroll', handleUserActivity);
        window.addEventListener('keydown', handleUserActivity);

        // Cleanup event listeners on unmount
        return () => {
            window.removeEventListener('mousemove', handleUserActivity);
            window.removeEventListener('scroll', handleUserActivity);
            window.removeEventListener('keydown', handleUserActivity);
        };
    }, [resetTimeout]);


    return (
        <div className="layout-footer" style={{}}>
            <span className="font-medium mx-2">Session Timeout: {formatTime(timeLeft)}</span>
            <img
                src={`/layout/images/logo-lix.png`}
                alt="Logo"
                style={{ width: '25px', height: 'auto' }}
            />
            <span className="ml-2">by</span>
            <span className="font-medium ml-2">Novamed</span>
        </div>
    );
};

export default AppFooter;
